const axios = require('axios');

const STORAGE_KEY: string = 'SAVERBOT_ADMIN_SAVED_HASH';

axios.interceptors.response.use((response: any) => {
  const savedHash: string | null = window.localStorage.getItem(STORAGE_KEY);

  if (savedHash) {
    window.location.hash = savedHash;
    window.localStorage.setItem(STORAGE_KEY, '');
  }

  return response;
}, (error: any) => {
  if (error.response.status === 401) {
    const redirect = window.location.origin;

    const { hash } = window.location;
    window.localStorage.setItem(STORAGE_KEY, hash);

    window.location.href = `/api/auth/login?callback=${redirect}`;
  }
  return Promise.reject(error);
});
